import React, { memo, useContext } from "react";
import { ChatContext } from "context/Context";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAlt, faWindowMinimize, } from "@fortawesome/free-solid-svg-icons";

const WindowHeader = () => {
    const { setChatWindowOpen } = useContext(ChatContext);
    return (
        <div className="d-flex flex-row-reverse">
            <Button
                variant="outline-secondary"
                className="border-0 me-3"
                size="sm"
                id="btnMinimiseChat"
                title="Minimise"
                onClick={() => setChatWindowOpen(prev => !prev)}
            ><FontAwesomeIcon icon={faWindowMinimize} />
            </Button>
            <Button
                id="handle"
                variant="outline-secondary"
                className="border-0 me-3"
                size="sm"
                title="Click and hold to drag">
                <FontAwesomeIcon icon={faArrowsAlt} />
            </Button>
        </div>
    );
}

export default memo(WindowHeader);